import type { InsuranceIndex } from '../../../types/InsuranceFeatureConfig';
import type { BelongingsFeatureConfig } from '../../../types/insurances/BelongingsFeatureConfig';
import { belongings as base } from './base';
import { belongings as CZ } from './CZ';
import { belongings as HU } from './HU';
import { belongings as RO } from './RO';
import { belongings as SK } from './SK';

export const belongingsConfig: InsuranceIndex<BelongingsFeatureConfig> = { base, CZ, HU, RO, SK };
